import {
  AfterContentInit,
  AfterViewInit,
  Component,
  OnInit
} from '@angular/core'
import { NewsService } from './services/news.service'
import { NavigationEnd, NavigationStart, Router } from '@angular/router'
import { DOCUMENT } from '@angular/platform-browser'

declare var jquery: any
declare var $: any

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  popupVisible = false
  popupVisible1 = false
  position: any = { my: 'top', at: 'top', of: window, offset: '0 0' }
  mostrar: boolean = false
  skin: any
  anim: boolean = false
  anim_intro: boolean = false
  constructor(private _router: Router, private news: NewsService) {
    this.skin = document.getElementsByClassName('skin')
  }
  change(skin) {
    this.anim = true
    setTimeout(() => {
      this.anim = false
    }, 2000)

    //this.skin[0].href='/assets/css/skin/'+skin;
  }
  change2(skin) {
    this.skin[0].href = '/assets/css/skin/' + skin
  }

  ngOnInit() {
    setTimeout(() => {
      this.anim_intro = true
      setInterval(() => {
        this.change('')
      }, 6000)
    }, 5000)
    this._router.events.subscribe(route => {
      if (route instanceof NavigationStart) {
        this.mostrar = true
      }
      if (route instanceof NavigationEnd) {
        this.mostrar = false
        $('html, body').animate({ scrollTop: 0 }, 'fast')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts